import React from "react";
import {Link} from "react-router-dom";
import { AddCircleOutlineOutlined, RemoveCircleOutlineOutlined } from '@mui/icons-material';
import {formatCurrency} from "../../utils";

function ExpenseListItem({item: r}) {
  let total = r?.lbp > 0 ? r.lbp : r.usd;
  let transactionType = total < 0 ? 'income' : 'expense'; // amounts are reversed in spreadsheet. Positive is expense
  const lbpFormatted = formatCurrency(r.lbp, 'LBP');
  const usdFormatted = formatCurrency(r.usd, 'USD');

  let amountPrimary = lbpFormatted ?? usdFormatted;
  let amountSecondary = r.lbp ? usdFormatted : null;


  if (r.usdlbp) {
    transactionType = r.usdlbp.usdTotal < 0 ? 'income' : 'expense';
    amountPrimary = formatCurrency(r.usdlbp.usdTotal, 'USD');
    const modifier = r.usdlbp.usd * r.usdlbp.lbp < 0 ? ' - ' : ' + ';
    amountSecondary =
      formatCurrency(r.usdlbp.usd, 'USD') +
      modifier +
      formatCurrency(r.usdlbp.lbp, 'LBP');
  }
  if (isNaN(r.date)) {
    console.warn('Date is NaN.', r);
  }
  return (<Link key={r.rowNumber} className={`transaction-row ${transactionType}`} to={`/expenses/${r.rowNumber}`}>
    <span className="account">{r.account || 'Cash'}</span>
    <span className="info-text">
      <span className={`category ${!r.category ? 'uncategorized' : ''}`}>{r.category || 'Uncategorized'}</span>
      <span className="description">{r.description}</span>
    </span>
    <span className="amount">
      <span className="amount-primary">

    <span className="type-icon">
      <RemoveCircleOutlineOutlined className="expense" />
      <AddCircleOutlineOutlined className="income" />
    </span>
        {amountPrimary}</span>
      {amountSecondary ? <span className="amount-secondary">{amountSecondary}</span> : null }
    </span>
  </Link>)
}

export default ExpenseListItem;
